// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"185":"slide-fullsize-vid","224":"slide-img-text","619":"slide-simple-text","851":"slide-highlighted-numbers","977":"slide-quote"}[chunkId] + "." + {"185":"c1d53ee8","224":"6eff5415","619":"e3b20eb1","851":"2b9f16dc","977":"c917c498"}[chunkId] + ".js";
};